<template>
  <div class="hot-tags-card">
    <el-card class="card" shadow="hover">
      <template #header>
        <i class="el-icon-collection-tag el-card-header-icon" />
        <span class="el-card-header-txt">热门标签</span>
      </template>
      <div class="tags-box">
        <el-tag :key="t.id" v-for="t in hotTags" class="tag" size="small" :type="randomTagType()" @click="toThisTag(t)">
          <i class="icon el-icon-collection-tag" /><span class="name">{{t.tagName}}</span>
        </el-tag>
        <!-- <el-tag class="tag" size="small" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">小嘬</span></el-tag>
        <el-tag class="tag" size="small" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">SpringSpring</span></el-tag>
        <el-tag class="tag" size="small" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">博客</span></el-tag>
        <el-tag class="tag" size="small" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">希望</span></el-tag>
        <el-tag class="tag" size="small" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">聊天</span></el-tag>
        <el-tag class="tag" size="small" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">SpringSpring</span></el-tag>
        <el-tag class="tag" size="small" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">美女</span></el-tag>
        <el-tag class="tag" size="small" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">帅哥</span></el-tag>
        <el-tag class="tag" size="small" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">黑客</span></el-tag>
        <el-tag class="tag" size="small" :type="randomTagType()"><i class="icon el-icon-collection-tag" /><span class="name">MybatisPlus</span></el-tag> -->
      </div>
    </el-card>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, toRefs } from 'vue'
import { getRandomFromArr, AssertGoodResponse } from '@/util/GlobalUtil'
import { useLog, useGetRequest } from '@/hooks'
import { useRoute, useRouter } from 'vue-router'
import { BlogConditionStrategies } from '@/interfaces'

export default defineComponent({
  setup() {
    // eslint-disable-next-line
    const l = useLog()
    const { name: currentRouteName } = useRoute()
    const router = useRouter()
    const randomTagType = () =>
      getRandomFromArr(['', 'info', 'danger', 'warning', 'success'])
    const state = reactive({
      hotTags: [],
    })
    // 调接口, 热门标签
    useGetRequest('/api/tag/hot', { topNum: 10 }).then((res) => {
      AssertGoodResponse(res)
      state.hotTags = res.data.data
    })
    // 跳转到conditon页面, 查看当前类型下的所有博客
    // eslint-disable-next-line
    const toThisTag = (tag: any) => {
      router
        .push({
          name: 'ConditionBlogs',
          query: {
            conditionStrategy: BlogConditionStrategies.BY_TAG,
            value: tag.id,
          },
        })
        .then(() => {
          // 为什么要这么写? 因为同路由跳转组件不会刷新, 只能在跳转成功之后的回调里自动刷新一下页面
          if (currentRouteName == 'ConditionBlogs') {
            router.go(0)
          }
        })
    }

    return { ...toRefs(state), randomTagType, toThisTag }
  },
})
</script>

<style lang="scss" scoped>
.hot-tags-card {
  margin-top: 20px;

  .tag {
    cursor: pointer;
    margin: 0 0px 10px 10px;
    transition: all 0.3s;
    .name {
      margin-left: 5px;
    }

    &:hover {
      transform: scale(1.1);
    }
  }
}
</style>